// @flow
import React from 'react';
import styled from 'styled-components';
import { FormikProps } from 'formik';
import moment from 'moment';

import DatePicker from 'antd/lib/date-picker';
import Input from 'antd/lib/input';
import InputNumber from 'antd/lib/input-number';
import Button from 'antd/lib/button';

import { tripStatusEnum } from './../../../../lib/enum';

import type { FormFieldType } from './../../../../components/Form';
import Form from './../../../../components/Form';
import { Section } from './../../../../components/layout';
import Grid, { GridItem } from './../../../../components/layout/Grid';
import CancelButton from './../../../../components/CancelButton';
import Selects from './../../../../components/selects';

const { RateTaxesSelect, TripSelect, CompanySelect } = Selects;

const StyledSection = styled(Section)`
  padding: 16px;
`;
const Footer = styled(Section)`
  padding: 16px;
  display: flex;
  justify-content: space-between;
`;
const StyledInputNumber = styled(InputNumber)`
  width: 100%;
`;

type Props = {
  onCancel: Function,
  onSubmit: Function,
  tripId?: number
};

export default ({ onCancel, onSubmit, tripId }: Props) => {
  return (
    <Form initialValues={{ tripId }} onSubmit={onSubmit}>
      {(
        FormField: FormFieldType,
        {
          setFieldValue,
          handleSubmit,
          handleBlur,
          values,
          dirty,
          isSubmitting
        }: FormikProps
      ) => {
        return (
          <form onSubmit={handleSubmit}>
            <StyledSection>
              <Grid gutter="16px" cols={2}>
                <GridItem>
                  <FormField
                    label="Номер документа"
                    name="documentNumber"
                    required
                  >
                    {({ name, value }) => {
                      return (
                        <Input
                          placeholder="Введите номер"
                          name={name}
                          value={value}
                          onChange={e => {
                            setFieldValue(name, e.target.value);
                          }}
                        />
                      );
                    }}
                  </FormField>
                </GridItem>
                <GridItem>
                  <FormField
                    name="documentDate"
                    label="Дата составления акта"
                    required
                  >
                    {({ name, value }) => (
                      <DatePicker
                        name={name}
                        value={value ? moment(value) : value}
                        format="DD MMMM YYYY"
                        onChange={(value: string) => {
                          setFieldValue(
                            name,
                            moment
                              .utc(value)
                              .startOf('day')
                              .toISOString()
                          );
                        }}
                      />
                    )}
                  </FormField>
                </GridItem>
                <GridItem>
                  <FormField name="tripId" label="Выберите путевой" required>
                    {({ name, value }) => (
                      <TripSelect
                        filter={{
                          isArchive: true,
                          status: tripStatusEnum.verified,
                          toOtherSide: true
                        }}
                        disabled={tripId}
                        value={value}
                        name={name}
                        onChange={(value: number) => setFieldValue(name, value)}
                      />
                    )}
                  </FormField>
                </GridItem>
                <GridItem>
                  <FormField
                    name="workHoursPrice"
                    label="Стоимость 1 маш/час (без  НДС)"
                    required
                  >
                    {({ name, value }) => (
                      <StyledInputNumber
                        min={0}
                        value={value}
                        onChange={value => setFieldValue(name, value)}
                      />
                    )}
                  </FormField>
                </GridItem>
                <GridItem>
                  <FormField name="tax" label="Ставка НДС" required>
                    {({ name, value }) => (
                      <RateTaxesSelect
                        value={value}
                        onChange={value => setFieldValue(name, value)}
                      />
                    )}
                  </FormField>
                </GridItem>
                <GridItem>
                  <FormField
                    label="Номер договора"
                    name="contractNumber"
                    required
                  >
                    {({ name, value }) => (
                      <Input
                        name={name}
                        value={value}
                        onChange={e => setFieldValue(name, e.target.value)}
                      />
                    )}
                  </FormField>
                </GridItem>
                <GridItem>
                  <FormField label="Дата договора" name="contractDate" required>
                    {({ name, value }) => (
                      <DatePicker
                        name={name}
                        value={value ? moment(value) : value}
                        format="DD MMMM YYYY"
                        onChange={(value: string) => {
                          setFieldValue(
                            name,
                            moment
                              .utc(value)
                              .startOf('day')
                              .toISOString()
                          );
                        }}
                      />
                    )}
                  </FormField>
                </GridItem>
                <GridItem>
                  <FormField label="Контрагент" name="companyId" required>
                    {({ name, value }) => (
                      <CompanySelect
                        name={name}
                        value={value}
                        onChange={(companyId: number) =>
                          setFieldValue(name, companyId)
                        }
                      />
                    )}
                  </FormField>
                </GridItem>
              </Grid>
            </StyledSection>

            <Footer>
              <Button
                disabled={isSubmitting}
                loading={isSubmitting}
                type="primary"
                htmlType="submit"
              >
                {values.id ? 'Сохранить' : 'Создать'}
              </Button>
              <CancelButton dirty={dirty} onClick={onCancel}>
                Отменить
              </CancelButton>
            </Footer>
          </form>
        );
      }}
    </Form>
  );
};
